import { bindServices } from '@/services/api';

const api = bindServices('servers');

import _ from 'lodash';

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const Model = {
  namespace: 'servers',
  state: {
    newServer: false,
    serverDetails: false,
    selectedItem: null,
    formConfig: null,
    list: [],
    pagination: meta,
    select: 'id,isActive',
    paramsView: {
      azureGraphSharePointConfiguration: {
        select:
          'id,isActive,clientId,username,updated,created,name,sharePointCompanyUrl,authorityUrl',
        expand: {
          userCreator: { select: 'fullName' },
          userModifier: { select: 'fullName' },
        },
      },
      azureGraphConfiguration: {
        select: 'id,isActive,clientId,username,updated,created',
        expand: {
          userCreator: { select: 'fullName' },
          userModifier: { select: 'fullName' },
        },
      },
      powerBIServerConfiguration: {
        select:
          'id,isActive,clientId,name,username,isAutoManaged,updated,created,isAutoManaged,resourceUrl,apiUrl,embedUrlBase,redirectUrl',
        expand: {
          userCreator: { select: 'fullName' },
          userModifier: { select: 'fullName' },
        },
      },
      emailServerConfiguration: {
        select:
          'id,isActive,fromEmail,fromName,port,enableSsl,useDefaultCredentials,serverType,updated,created',
        expand: {
          userCreator: { select: 'fullName' },
          userModifier: { select: 'fullName' },
        },
      },
    },
    paramsEdit: {
      azureGraphSharePointConfiguration: {
        select: 'id,isActive,clientId,username,name,sharePointCompanyUrl,authorityUrl',
      },
      azureGraphConfiguration: {
        select: 'id,isActive,clientId,username',
      },
      powerBIServerConfiguration: {
        select:
          'id,isActive,clientId,name,username,isAutoManaged,isAutoManaged,resourceUrl,apiUrl,embedUrlBase,redirectUrl',
      },
      emailServerConfiguration: {
        select: 'id,isActive,fromEmail,fromName,port,enableSsl,useDefaultCredentials,serverType',
      },
    },
    view: false,
    orderBy: '',
    server: '',
    serverAdd: 'azureGraphSharePointConfiguration',
    id: '',
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const response = yield call(api.getAll, {
          route: payload.route,
        });
        let list = [];
        if (payload.route === 'servers/list') {
          // TODO: refactoring
          _.each(_.keys(response), (item) => {
            _.each(response[item], (l) => {
              list.push({
                ...l,
                nameServer: item.slice(0, -1),
              });
            });
          });
        } else {
          list = _.map(response, (l) => {
            return {
              ...l,
              nameServer: payload.route,
            };
          });
        }
        yield put({
          type: 'queryServers',
          payload: {
            list,
          },
        });
      } catch (error) {
        /*  */
      }
    },
    *addNewServer({ payload }, { put }) {
      yield put({
        type: 'addServers',
        payload,
      });
      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewServer',
          payload,
        });
      }
    },
    *saveNewServer({ payload }, { call, put }) {
      try {
        const response = yield call(api.create, {
          route: payload.route,
          data: payload.data,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveServer',
          payload: response,
          server: payload.route,
        });
        yield put({
          type: 'fetchList',
          payload: {
            params: payload.params,
            route: payload.serverRoute || 'servers/list',
          },
        });
      } catch (error) {
        if (error && error.message) {
          // TODO: avoid direct pos access
          if (error.validationErrors && _.isEmpty(error.validationErrors[0].field)) {
            _.set(error, 'message', error.validationErrors[0].errorMessages[0]);
          }
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors || [],
          });
        }
      }
    },
    *editItemServer({ payload }, { call, put }) {
      try {
        yield put({
          type: 'global/loadingItem',
          payload: true,
        });
        const table = yield call(api.getById, {
          route: payload.route,
          id: payload.id,
          params: payload.params,
        });
        yield put({
          type: 'editServers',
          payload: {
            ...payload,
            state: true,
            item: table,
          },
        });
        yield put({
          type: 'global/loadingItem',
          payload: false,
        });
      } catch (error) {
        yield put({
          type: 'global/loadingItem',
          payload: false,
        });
      }
    },
    *saveEditServer({ payload }, { call, put }) {
      try {
        const response = yield call(api.update, {
          route: payload.route,
          data: payload.data,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });

        yield put({
          type: 'saveServer',
          payload: response,
          server: payload.route,
        });

        yield put({
          type: 'fetchList',
          payload: {
            route: payload.serverRoute || 'servers/list',
          },
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },
    *deleteItem({ payload }, { call, put }) {
      try {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });
        const response = yield call(api.apiRoute, {
          route: `${payload.route}/${payload.id}`,
          method: 'delete',
        });
        yield put({
          type: 'saveServer',
          payload: response,
          server: payload.route,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'fetchList',
          payload: {
            params: payload.params,
            route: payload.server || 'servers/list',
          },
        });
      } catch (error) {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });
        if (error && error.message) {
          yield put({
            type: `global/showNotifications${payload.view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: payload.view,
            },
          });
        }
      }
    },

    *showItemUser({ view }, { put }) {
      yield put({
        type: 'showEditItemUser',
        view,
      });
    },
    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },
    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },
    *viewServerDetails({ payload }, { put }) {
      yield put({
        type: 'viewServer',
        payload,
      });
    },
    *selectionChange({ payload }, { put }) {
      yield put({
        type: 'selectionChanges',
        payload,
      });
    },
    *showItemServer({ view }, { put }) {
      yield put({
        type: 'showEditItemServer',
        view,
      });
    },
  },
  reducers: {
    queryServers(state, { payload }) {
      return {
        ...state,
        list: payload.list,
      };
    },

    addServers(state, { payload }) {
      return {
        ...state,
        newServer: payload.state,
        selectedItem: payload.item,
        view: payload.view,
        serverAdd: payload.server,
        id: payload.id,
      };
    },
    editOrViewServers(state) {
      return {
        ...state,
        selectedItem: {},
      };
    },

    editServers(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.item,
        view: payload.view,
        serverAdd: payload.server,
        id: payload.id,
      };
    },

    saveServer(state, { payload }) {
      return {
        ...state,
        saveServer: payload,
        newServer: false,
        selectedItem: null,
        view: false,
      };
    },

    editActives(state, { payload }) {
      const list = state.list.map((item) => (item.id === payload.id ? payload : item));

      return {
        ...state,
        list,
      };
    },

    showEditItemServer(state, { view }) {
      return {
        ...state,
        view,
      };
    },

    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },

    viewServer(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.item,
        serverDetails: payload.state,
      };
    },

    selectionChanges(state, { payload }) {
      return {
        ...state,
        server: payload.server,
      };
    },

    hideForms(state) {
      return {
        ...state,
        newServer: false,
        selectedItem: null,
        formConfig: null,
        list: [],
        view: false,
        orderBy: '',
        server: '',
        id: '',
      };
    },
  },
};

export default Model;
